import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
  
const UserCreate = ()=>{
    // const [userUuid, setUserUuid ] = useState('');
     const [roleId, setRoleId ] = useState('');
     const[roleList, setRoleList] = useState([]);
     const [page,setPage] = useState(1);
     const [phoneNumber, setPhoneNumber ] = useState('');
     const [emailNew, setEmailNew ] = useState('');
     const [lastName, setLastName ] = useState('');
     const [firstName, setFirstName ] = useState('');
     const[passwordNew,setPasswordNew] = useState('');
     const [redirect, setRedirect] = useState(false);

     useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`role?page=${page}`);
            setRoleList(data.data);
            //console.log(data); 

        }
        )();
    },[page]);

     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('users', {
            init_password:passwordNew,
            role_id:parseInt(roleId),
            msisdn:phoneNumber,
            email:emailNew,
            last_name:lastName,
            first_name:firstName,
        });
        //console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/users'} />
    }
     return (
         <Wrapper pageTitle={"New User"}>
            <InnerNav createLink={'/userCreate'} listLink={'/users'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
 
 
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">First Name </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="FirstName"
                        onChange = {e => setFirstName(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Last Name </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="LastName"
                        onChange = {e => setLastName(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Phone Number</span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="LastName"
                        onChange = {e => setPhoneNumber(e.target.value)} />
                    </label>
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Email </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Email"
                        onChange = {e => setEmailNew(e.target.value)} />
                    </label>
               
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Role  </span>
                        <select onChange={(e) => setRoleId(e.target.value)}  className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input ">
                            <option value="0">Choose Role</option>
                            {roleList.map(role => (
                                <option key={role.id} value={role.id}>
                                    {role.name}
                                </option>
                            ))}
                        </select>
                    </label>
                   
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Password </span>
                        <input type='password'
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                       
                        onChange = {e => setPasswordNew(e.target.value)} />
                    </label>


                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default UserCreate;